{
  "gender": {
    "if": {
      "properties": {
        "gender": {
          "enum": ["Female"]
        }
      },
      "required": ["gender"]
    },
    "then": {
      "properties": {
        "pregnant": {
          "x-include-in-requisition": true,
          "$ref": "#/definitions/pregnant"
        },
        "birthLastFourWeeks": {
          "x-include-in-requisition": true,
          "$ref": "#/definitions/birthLastFourWeeks"
        }
      },
      "required": ["pregnant", "birthLastFourWeeks"]
    }
  },
  "treatmentLastFourWeeks": {
    "if": {
      "properties": {
        "treatmentLastFourWeeks": {
          "enum": ["Yes"]
        }
      },
      "required": ["treatmentLastFourWeeks"]
    },
    "then": {
      "properties": {
        "treatmentDescription": {
          "x-include-in-requisition": true,
          "$ref": "#/definitions/treatmentDescription"
        }
      },
      "required": ["treatmentDescription"]
    }
  },
  "produksjonstype": {
    "if": {
      "properties": {
        "produksjonstype": {
          "enum": [
            "HOBBY_FJORFE"
          ]
        }
      },
      "required": ["produksjonstype"]
    },
    "then": {
      "properties": {
        "verdikjede": {
          "x-include-in-requisition": true,
          "$ref": "#/definitions/verdikjede",
          "oneOf": [
            {
              "const": "FJOERFE",
              "title": "Fjørfe"
            },
            {
              "const": "FUGLER_I_FANGENSKAP",
              "title": "Fugler i fangenskap"
            }
          ]
        }
      },
      "required": ["verdikjede"]
    },
    "else": {
      "properties": {
        "verdikjede": {
          "x-include-in-requisition": true,
          "$ref": "#/definitions/verdikjede",
          "oneOf": [
            { "const": "KONSUMEGG", "title": "Konsumegg" },
            { "const": "SLAKTEFJORFE", "title": "Slaktefjørfe" },
            {
              "const": "GJENOPPBYGGE_FUGLEVILTBESTAND",
              "title": "Gjenoppbygge fugleviltbestand"
            }
          ]
        }
      },
      "required": ["verdikjede"]
    }
  },
  "produksjonstypeStorfe": {
    "if": {
      "properties": {
        "produksjonstype": {
          "enum": ["KJOTTFE_AMMEKU", "MJOLKEKU"]
        }
      },
      "required": ["produksjonstype"]
    },
    "then": {
      "properties": {
        "verdikjede": {
          "x-include-in-requisition": true,
          "$ref": "#/definitions/verdikjedeStorfe"
        }
      },
      "required": ["verdikjede"]
    },
    "else": {
      "properties": {
        "verdikjede": {
          "x-include-in-requisition": true,
          "$ref": "#/definitions/verdikjedeStorfe"
        }
      },
      "required": ["verdikjede"]
    }
  },
  "produksjonstypeSvin": {
    "if": {
      "properties": {
        "produksjonstype": {
          "enum": [
            "AVLSBESETNING_FOREDLING",
            "AVLSBESETNING_FORMERING",
            "NAV",
            "SATELLITT",
            "BRUKSBESETNING_SMAGRIS",
            "BRUKSBESETNING_KOMBINERT",
            "BRUKSBESETNING_SLAKTEGRIS",
            "SEMINSTASJON"
          ]
        }
      },
      "required": ["produksjonstype"]
    },
    "then": {
      "properties": {
        "verdikjede": {
          "x-include-in-requisition": true,
          "$ref": "#/definitions/verdikjedeSvin"
        }
      },
      "required": ["verdikjede"]
    },
    "else": {
      "properties": {
        "verdikjede": {
          "x-include-in-requisition": true,
          "$ref": "#/definitions/verdikjedeSvin"
        }
      },
      "required": ["verdikjede"]
    }
  }
}
